export default "__VITE_ASSET__BAzWoFWW__"